import { Typography } from '@mui/material'
import { growthDisplay } from './growthDisplay'

interface Props {
  growth: number
  /** The previous-period baseline cell — definitionally Δ 0 (it IS the Δ reference). */
  baseline?: boolean
}

/** Wave-4 §2 (D3): ONE growth chip for every surface. Direction × color (status pair,
 *  reserved) + arrow glyph — never color alone. Zero and baseline render neutral.
 *  Wave-5 §3 (D4): the mapping lives in growthDisplay, shared with SummaryBarStrip. */
export function GrowthChip({ growth, baseline = false }: Props) {
  const d = growthDisplay(growth, baseline)
  if (d === null) return null
  return (
    <Typography
      variant="caption"
      component="span"
      noWrap
      data-testid="growth-chip"
      sx={{
        color: d.color ?? 'text.secondary',
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      {d.text}
    </Typography>
  )
}
